import { createAction, props } from '@ngrx/store';

import { ReviewDetails } from '@app/features/review/models/review-details';

export const loadReviewDetails = createAction(
  '[ReviewResolver] Load Review Details',
  props<{reviewDetails: ReviewDetails}>()
);

export type ReviewActionsUnion = ReturnType<typeof loadReviewDetails>;
